import { render } from "./P074.vue?vue&type=template&id=2d0a0b2d&scoped=true"
import script from "./P074.vue?vue&type=script&lang=js"
export * from "./P074.vue?vue&type=script&lang=js"

import "./P074.vue?vue&type=style&index=0&id=2d0a0b2d&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0a0b2d"]])

export default __exports__